import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { sources } from '../api/sources';
import { useGlobalState } from '../shared/state';
import { Error, ErrorType } from '../shared/types';
import { Pages } from '../shared/pages';
import LogCannon from '@ace-clublabs/log-cannon';
import Spinner from '../components/Spinner';
import { MANIFEST_TTL_MS } from '../constants';

const PaymentRouter: React.FC = () => {
  const { id } = useParams<{ id: string }>() ?? { id: undefined };
  const [, setManifest] = useGlobalState('manifest');
  const [, setPaymentType] = useGlobalState('paymentType');
  const [skipLanding, setSkipLanding] = useGlobalState('skipLanding');
  const [manifestId, setManifestId] = useGlobalState('manifestId');
  const [, setScheduledDate] = useGlobalState('scheduledDate');
  const [, setError] = useGlobalState('error');
  const [manifestTimestamp, setManifestTimestamp] = useGlobalState('manifestTimestamp');
  const [, setIsScheduled] = useGlobalState('isScheduled');
  const [, setSoftErrorFormRedirectDone] = useGlobalState('softErrorFormRedirectDone');

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const isManifestStale = !!manifestTimestamp && Date.now() - manifestTimestamp > MANIFEST_TTL_MS;
      try {
        if (!skipLanding) {
          // if (id === undefined) { // TODO: add a handler for the case when manifest doesn't exist
          //   throw { message: "manifest doesn't exist", type: ErrorType.MANIFEST_ERROR };
          // }
          setIsScheduled(false);
          setSkipLanding(true);
          if (manifestId !== id) {
            setScheduledDate(undefined);
            setSoftErrorFormRedirectDone(false);
          }
          setManifestId(id);
          const _manifest = await sources.getManifest(id ?? '');
          setManifest(_manifest);
          setManifestTimestamp(Date.now());
          setPaymentType(_manifest?.paymentType);
          const renderSchedulePayment = _manifest.schedulePayment?.enabled && _manifest.schedulePayment?.minimumDueDate;
          if (renderSchedulePayment) navigate(Pages.SchedulePayment);
          else navigate(Pages.PaymentMethods);
        } else {
          setSkipLanding(false);
          navigate(-1);
        }
      } catch (e: any) {
        const errorType = isManifestStale ? ErrorType.SESSION_TIMEOUT : e.type;
        const error: Error = { errorMessage: e.message, errorType };
        setManifest(undefined);
        setError(error);
        LogCannon.blast(isManifestStale ? 'Navigating to Session Error' : 'Navigating to Error', {
          component: 'PaymentRouter',
          errorMessage: 'ERROR: Error occurred on PaymentRouter',
          error: typeof error === 'string' ? `${error}` : error,
          ...(isManifestStale && { manifestExpiredAfterMs: Date.now() - manifestTimestamp!, expiredManifestId: id }),
        });
        navigate(Pages.Error);
      }
    })();
  }, [id]);

  return <Spinner />;
};

export default PaymentRouter;
